export default "__VITE_ASSET__9d9a98fe__"